(function(){
  'use strict'; // opt out of "sloppy mode" this is only applyed to this function however so will not break other code

  angular
    .module('iqxCore')
    .controller('SettingsAccessibilityCtrl', UserSettingsAccessibilityCtrl)
  
  function UserSettingsAccessibilityCtrl($scope) {
    var accessibilitySettings = this

    accessibilitySettings.viewTab = viewTab
    accessibilitySettings.activeTab = ''

    activate()

    ///////////

    function activate(){
      accessibilitySettings.activeTab = 'account'
    }

  
    function viewTab(tab){
      accessibilitySettings.activeTab = tab
    }
  }
})()
